


























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ApiV2Service } from '@/services/api.base.service';
import AceEditor from 'vue2-ace-editor';
import 'brace/mode/javascript';
import 'brace/theme/clouds';
import Dialog from '@/components/Dialog.vue';

@Component({
  components: {
    Dialog,
    AceEditor,
  },
})
export default class BarcodeFunctions extends Vue {
  @Prop({ default: {} }) private deviceType!: any;
  private showHelp: boolean = false;
  private showTest: boolean = false;
  private testPayload: string = '';
  private testResponse: string = '';
  private dialog: boolean = false;
  private version: string = '0';
  private showTestFunctionModal: boolean = false;
  private toggleHelpModal: boolean = false;
  private validationWarnings: string = '';

  private DEFAULT_MAPPING_FUNCTION = `(barcodeString) => {\n\treturn {}\n}`;

  private mounted() {
    Vue.set(this, 'version', this.deviceType.configuration.executionVersion);
  }

  private editorInit(editor: any) {
    editor.setOptions({
      fontSize: '1em',
    });
  }
  @Watch('deviceType', { deep: true, immediate: true })
  private setDefaultFunction() {
    if (!this.deviceType.configuration.barcodeFunction) {
      this.deviceType.configuration.barcodeFunction = this.DEFAULT_MAPPING_FUNCTION;
    }
  }

  private async showTestFunction() {
    this.testResponse = '';
    this.showHelp = false;
    this.showTest = true;
  }

  private resetDialog() {
    this.dialog = false;
    this.version = this.deviceType.configuration.executionVersion;
    this.validationWarnings = '';
  }

  private async testFunction() {
    this.validationWarnings = '';

    const strippedPayload = this.testPayload;
    if (!this.testPayload) {
      this.testResponse = 'Invalid Payload';
      return;
    }
    const { result } = await ApiV2Service.post(`admin/deviceVersion/test`, {
      code: this.deviceType.configuration.barcodeFunction,
      payload: strippedPayload,
      port: '',
    });

    this.testResponse = JSON.stringify(result, null, '\t');

    if (!this.testResponse) {
      this.testResponse = 'Empty response';
    }
  }

  private saveBarcodeFunction() {
    this.$emit('saveDeviceType', this.deviceType);
  }

  private toggleHelp() {
    this.showTest = false;
    this.showHelp = !this.showHelp;
  }
}
